export enum VariableState {
  INUSE = 'inuse',
  ARCHIVED = 'archived',
  STALE = 'stale',
  UNPUBLISHED = 'unpublished',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const VARIABLES_PARAM_SEARCH_KEY = 'search';
export const VARIABLES_PARAM_PAGENO_KEY = 'pageNo';
export const VARIABLES_PARAM_PAGESIZE_KEY = 'pageSize';
export const VARIABLES_PARAM_SORTBY = 'sortBy';
export const VARIABLES_PARAM_ORDER = 'order';
export const VARIABLES_PARAM_STATE = 'defaultState';
export const VARIABLES_PARAM_STATES = 'states';
export const VARIABLES_TAB_VIEW = 'tab';
export const VARIABLES_PARAM_OWNER = 'createdBy';
export const VARIABLES_PARAM_MINEONLY = 'mineOnly';
export const VARIABLES_PARAM_COMPLEXITY_LEVELS = 'complexityLevels';
export const VARIABLES_PARAM_GUARDRAIL_VIOLATED = 'guardrailViolated';

export enum VariableType {
  STRING = 'string',
  INT64 = 'int64',
  FLOAT64 = 'float64',
  MAP = 'map',
  JSON = 'json',
  FILE = 'file',
  BOOLEAN = 'boolean',
}
